import React from 'react';

import SCEcommerceLogin from './css';
import { Link } from 'react-router-dom';

import { reduxForm, Field, SubmissionError } from 'redux-form';
import axios from '../../util/payrightAxios';
import history from '../../history';
import { RenderInput } from '../Common/FormFields';
import { connect } from 'react-redux';

import { Button, IconLogo } from '@payright/web-components';

let LoginForm = (props) => {
  const { error, handleSubmit, pristine, submitting, apiErrors } = props;

  const [displayMfaForm, setDisplayMfaForm] = React.useState(false);
  const [requestId, setRequestId] = React.useState(null);
  const [phoneNumberHint, setPhoneNumberHint] = React.useState('');

  const onSubmit = (values) => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const url = `${apiBaseUrl}/customer/login`;

    const payload = !displayMfaForm
      ? { username: values.username, password: values.password }
      : {
          username: values.username,
          password: values.password,
          request_id: requestId,
          code: values.code,
        };

    return axios(url, {
      method: 'POST',
      data: payload,
    })
      .then((response) => {
        const data = response?.data?.data;
        if (!displayMfaForm && data?.mfa_required) {
          setDisplayMfaForm(true);
          setRequestId(data.requestId);
          setPhoneNumberHint(data.phoneNumberHint);
          return; // show MFA form
        }
        props.dispatch({ type: 'SIGN_IN', payload: response });
        history.push('/dashboard');
      })
      .catch((error) => {
        props.dispatch({ type: 'API_UPDATE_FAILURE', payload: error });
        throw new SubmissionError({
          _error: displayMfaForm
            ? 'Invalid verification code. Please try again'
            : 'Invalid Username or Password. Please try again',
        });
      });
  };

  if (localStorage.getItem('isSignedIn')) {
    history.push('/dashboard');
  }

  return (
    <SCEcommerceLogin>
      <div className="ecommerce-image" />
      <div className="login-wrapper">
        <div className="login-header">
          <div className="logo">
            <IconLogo width={180} height={74} />
          </div>
          <h4>Login</h4>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="loginForm">
          {(error || apiErrors) && <div className="validation-msg-box">{error || apiErrors}</div>}

          {displayMfaForm ? (
            <>
              <p style={{ marginBottom: '2em' }}>
                Please enter the verification code that was sent to your mobile at {phoneNumberHint}
                .
              </p>
              <Field name="username" type="hidden" component="input" />
              <Field name="password" type="hidden" component="input" />
              <Field
                placeholder="Verification code"
                name="code"
                type="text"
                label="Verification code"
                component={RenderInput}
              />
              <div className="back-confirm">
                <Link
                  to="#"
                  onClick={(e) => {
                    setDisplayMfaForm(false);
                    setRequestId(null);
                    setPhoneNumberHint('');
                  }}
                >
                  Back
                </Link>
                <Button withShadow maxWidth="80%" type="submit" disabled={submitting}>
                  Verify
                </Button>
              </div>
            </>
          ) : (
            <>
              <Field
                placeholder="Email address"
                name="username"
                label="Email address"
                type="text"
                component={RenderInput}
              />

              <Field
                placeholder="Password"
                name="password"
                type="password"
                label="Password"
                component={RenderInput}
              />

              <div className="forgot-password">
                <Link to="/forgot-password">
                  <span className="hide-mobile">I've forgotten my password</span>
                  <span className="mobile-only">Forgot password?</span>
                </Link>
              </div>
              <Button withShadow maxWidth="100%" type="submit" disabled={pristine || submitting}>
                Login
              </Button>
            </>
          )}
        </form>
      </div>
    </SCEcommerceLogin>
  );
};

LoginForm = reduxForm({
  form: 'LoginForm',
})(LoginForm);

const mapStateToProps = (state) => {
  return {
    apiErrors: state.error.errors,
  };
};

export default connect(mapStateToProps)(LoginForm);
